import React from 'react';
import moment from 'moment';
import cx from 'classnames';
import { ReactComponent as DriverIcon } from 'assets/icons/truck-in-circle.svg';
import { ReactComponent as MessageDeliveredIcon } from 'assets/icons/check-1.svg';
import { ReactComponent as MessageReadByDriverIcon } from 'assets/icons/check-double-1.svg';

import { contentTypeToExtension, downloadBlob, removeSignature } from './utils';
import Linkify from 'react-linkify';
import { getDownloadImageBlob } from 'modules/chat/Conversation/http';
import styled from 'styled-components';

const StyledDeliveredDiv = styled.div`
      div {
        display: flex;
        justify-content: end;
        color: #CBD5DF;
        font-weight: bold;
        font-style: italic;
        font-size: 1.4rem;
        margin-bottom: 3px;
        svg path {
          fill: #CBD5DF;
        }
      }
    }
`;
const linkifyProps = { target: '_blank' };

const handleImageClick = async (image) => {
  const blob = await getDownloadImageBlob(image.link);
  const extension = contentTypeToExtension(blob.type);
  const name = `${image.name}.${extension}` || 'no_name';
  downloadBlob(blob, name);
};

const Message = ({
  message,
  sender,
  timestamp,
  attachments,
  className,
  read_by_driver,
  message_id,
  last_message_read_by_driver,
  last_read_by_driver_at,
}) => {
  const isAgent = sender && (sender.agent || sender.name === 'Ontruck');
  const readByDriver = read_by_driver && read_by_driver === true;
  const name = sender && sender.name;
  const time = timestamp && moment(timestamp).format('HH:mm');
  const isTheLastMessageReadByDriver = message_id && message_id === last_message_read_by_driver;
  const last_seen_by_driver_at = last_read_by_driver_at;
  const messageFormatted = !!message && (
    <Linkify properties={linkifyProps}>{removeSignature(message)}</Linkify>
  );
  const image = Array.isArray(attachments) &&
    attachments.length > 0 && {
      name: attachments[0].file_name,
      link: attachments[0].content_url,
    };
  return (
    <>
      <div className={className} data-testid="conversationMessage">
        {!isAgent && (
          <div className="driver-icon">
            <DriverIcon />
          </div>
        )}
        <div className={cx('message', { 'driver-skin': !isAgent, 'agent-skin': isAgent })}>
          {!image && (
            <MessageBody
              name={name}
              time={time}
              message={messageFormatted}
              read_by_driver={readByDriver}
            />
          )}
          {image && (
            <MessageBodyWithImage
              name={name}
              time={time}
              image={image}
              read_by_driver={readByDriver}
            />
          )}
        </div>
      </div>
      <StyledDeliveredDiv>
        {isAgent && readByDriver && (
          <div data-testid="read-driver-icon">
            <MessageReadByDriverIcon />
          </div>
        )}
        {isAgent && readByDriver && isTheLastMessageReadByDriver && (
          <div>Seen, {formatDate(last_seen_by_driver_at)}</div>
        )}
        {isAgent && !readByDriver && (
          <div data-testid="delivered-icon">
            <MessageDeliveredIcon />
            &nbsp;Delivered
          </div>
        )}
      </StyledDeliveredDiv>
    </>
  );
};

const MessageBody = ({ name = '', message = '', time = '' }) => {
  return (
    <>
      <div className="message__author">
        <span> {name} </span>
      </div>

      <div className="message__content">
        <span className="message__text">{message}</span>
        <span data-testid="message-time" className="message__time">
          {time}
        </span>
      </div>
    </>
  );
};

const MessageBodyWithImage = ({ name = '', image = '', time = '' }) => {
  return (
    <>
      <div className="message__author">
        <span> {name} </span>
        <span data-testid="message-time" className="message__time">
          {time}
        </span>
      </div>

      <div className="message__content">
        <span className="message__text">
          <img
            src={image.link}
            alt="img"
            className="message__image"
            onClick={(e) => handleImageClick(image)}
            data-testid="message-image"
          />
        </span>
      </div>
    </>
  );
};

export default Message;

export function formatDate(timestamp) {
  const dateFormat = 'DD MMM yyyy HH:mm';

  return moment(timestamp).format(dateFormat);
}
